import { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './ExceptionItem.module.css'
import { getSQLDateFormat, getAdjustedDate } from '../../utilities/general-utils'

import { IconCloseBold, IconCaution, IconCautionRecurring, IconAngleRightBold } from '../../assets/icons'
import { TransactionDisplayContext } from '../../contexts/transaction-display-context'

export const getExceptionLink = (
    transaction,
    exception,
    createLinkToOriginal,
) => {
    let instanceDate = getSQLDateFormat(transaction.instanceDate)

    if (exception && createLinkToOriginal) {
        instanceDate = getSQLDateFormat(exception.firstExceptionInstanceDate)
    }

    if (transaction.daysAdjusted) {
        instanceDate = getSQLDateFormat(getAdjustedDate(
            new Date(transaction.instanceDate).toISOString(),
            -transaction.daysAdjusted
        ))
    }

    const existingExceptionIdParam = exception ? `?exceptionId=${exception.exceptionId}` : ''

    return `/exception/${transaction.id}/${instanceDate}${existingExceptionIdParam}`
}

const NewExceptionLink = ({transaction}) => {
    return (
        <Link
            className="button button-small button-green dis-block text-center"
            to={getExceptionLink(transaction)}
        >
            Add Exception <IconAngleRightBold fill="#fff" />
        </Link>
    )
}

const ExceptionInfo = ({ transaction, onClose }) => {
    const { transactionDisplaySettings } = useContext(TransactionDisplayContext);

    return (
        <div className={styles.exceptionInfo}>
            <div className={styles.exceptionInfoClose} onClick={() => onClose()}>
                <IconCloseBold style={{display: "block", width: ".75em", height: ".75em"}} />
            </div>

            {!transactionDisplaySettings.hideExceptionLinkToTransactions && (
                <div className="spc-m-b-1">
                    <Link className="button button-blue button-small dis-block text-center" to={`/transaction/${transaction.id}`}>View Transaction <IconAngleRightBold fill="#fff" /></Link>
                </div>
            )}

            <NewExceptionLink transaction={transaction} />

            {transaction.exceptionItems && 
                transaction.exceptionItems.map((exceptionItem, index) => (
                    <div
                        key={`${index}-${exceptionItem.exceptionId}`}
                        className={styles.exceptionItem}
                    >
                        <Link
                            className="button button-small dis-block text-center"
                            to={getExceptionLink(
                                transaction,
                                exceptionItem,
                                true,
                            )}
                        >
                            Edit Exception [{exceptionItem.exceptionId}]
                        </Link>

                        <ul className={styles.exceptions}>
                            <li>
                                <span className="text-weight-bold">Repeats:</span>{' '}
                                {exceptionItem.isSeries ? 'Yes' : 'No'}
                            </li>
                            <li>
                                <span className="text-weight-bold">Start:</span> {' '}
                                {new Date(exceptionItem.firstExceptionInstanceDate).toDateString()}
                            </li>
                            {
                                exceptionItem.isSeries && (
                                    <li>
                                        <span className="text-weight-bold">End:</span>{' '}
                                        {new Date(exceptionItem.endDate).toDateString()}
                                    </li>
                                )
                            }
                            <li>
                                <div>
                                    <span className="text-weight-bold">Effects</span>
                                    <span style={{marginLeft: '0.5rem', backgroundColor: '#e2e8f0', padding: '0.125rem 0.5rem', borderRadius: '12px', fontSize: '80%'}}>
                                        {exceptionItem.exceptionEffects ? exceptionItem.exceptionEffects.length : 0}
                                    </span>
                                </div>
                                {exceptionItem.exceptionEffects &&
                                    (
                                        <ul className={styles.exceptionEffects}>
                                            {
                                                exceptionItem.exceptionEffects.map(
                                                    (exception, index) => (
                                                        <li key={`${index}-${exceptionItem.exceptionId}-${exception.type}`}>
                                                            {
                                                                exception.type === 'amount' &&
                                                                <div data-type="amount">
                                                                    <strong>Amount Changed</strong><br />
                                                                    <span style={{textDecoration: 'line-through', fontStyle: 'italic', color: '#64748b'}}>${parseFloat(exceptionItem.originalAmount).toFixed(2)}</span>
                                                                    {' → '}
                                                                    <span style={{color: '#059669', fontWeight: '600'}}>${parseFloat(exception.data.amount).toFixed(2)}</span>
                                                                </div>
                                                            }
                                                            {
                                                                exception.type === 'paid' &&
                                                                <div data-type="paid">
                                                                    <strong>Marked as Paid</strong>
                                                                </div>
                                                            }
                                                            {
                                                                exception.type === 'cancelled' &&
                                                                <div data-type="cancelled">
                                                                    <strong>Cancelled</strong>
                                                                </div>
                                                            }
                                                            {
                                                                exception.type === 'rescheduled' &&
                                                                <div data-type="rescheduled">
                                                                    <strong>Rescheduled</strong>
                                                                    <div style={{marginTop: '0.5rem', fontSize: '90%', color: '#64748b'}}>
                                                                        <div>Days Adjusted: <span style={{fontWeight: '600'}}>{exception.data.daysAdjusted}</span></div>
                                                                        <div>New Date: <span style={{fontWeight: '600'}}>{new Date(exception.data.date).toDateString()}</span></div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                exception.type === 'highlight' &&
                                                                <div data-type="highlight">
                                                                    <strong>Highlighted</strong>
                                                                </div>
                                                            }
                                                            {/* <pre>{ JSON.stringify(exception, null, 4) }</pre> */}
                                                        </li>
                                                    ),
                                                )
                                            }
                                        </ul>
                                    )
                                }
                            </li>
                        </ul>
                    </div>
                ))
            }
        </div>
    )
}

const ExceptionItem = ({ transaction, className }) => {
    const [showInfo, setShowInfo] = useState(false)
    const activeState = showInfo || transaction.exceptionItems;

    return (
        <div className={`${styles.exceptionWrap} ${className} ${activeState ? styles.exceptionWrapActive : ''}`}>
            <button
                className={`button button-small button-transparent ${styles.exceptionButton}`}
                onClick={() => setShowInfo(!showInfo)}
            >
                {transaction.exceptionItems && transaction.exceptionItems.some(item => item.isSeries) ? <IconCautionRecurring /> : <IconCaution />}
            </button>
            {showInfo && <ExceptionInfo transaction={transaction} onClose={setShowInfo} />}
        </div>
    )
}

export default ExceptionItem
